// @ts-nocheck
class WIcartDrawer extends HTMLElement{
    constructor() {
        super();
        this.addEventListener('click', this.closeCart.bind(this));
        this.addEventListener('click', this.cartBgclick.bind(this));
        document.addEventListener('openCart', this.openCart.bind(this));
    }
    connectedCallback(){
        this.clickOncart();
           document.addEventListener('opencart', ()=>{
            this.openCart();
            let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
            let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
            console.log(loadingCartBlock);
                if (loadingCartBlock) {
                    loadingCartBlock.style.display = "block";
                }
                if (emptyCart) {
                    emptyCart.style.display = "none";
                }
        })
    }

    clickOncart() {
        document.querySelectorAll('.WI_cart-link').forEach(cart=>{
            cart.addEventListener('click', (e)=>{
            e.preventDefault();
            this.openCart();
        });
        });
    }
    openCart() {
        let cartDrawer = this.querySelector('.WI_cartDrawerin');
        let cartDrawerUpsell = this.querySelector('.WI_cartDrawerin_upsell');
        document.body.style.overflow = "hidden";
        this.style.display = "flex";
        setTimeout(() => {
            this.style.backgroundColor = 'rgba(0,0,0,0.8)';
            cartDrawer.classList.add('WI_cartDrawerinActive');
        },10);
        
    }
    closeCart(event) {
        if (event.target.matches('.WI_cartDrawerCls')) {
            let cartDrawer = this.querySelector('.WI_cartDrawerin');
             document.body.style.overflow = "auto";
            setTimeout(() => {
                this.style.backgroundColor = 'rgba(0,0,0,0)';
                cartDrawer.classList.remove('WI_cartDrawerinActive');
                setTimeout(() => {
                    this.style.display = "none";
                },310);
            },10);
        }
    }
    cartBgclick(event) {
        if (event.target.matches('wi-cartdrawer')) {
            let cartDrawer = this.querySelector('.WI_cartDrawerin');
            document.body.style.overflow = "auto";
            setTimeout(() => {
                this.style.backgroundColor = 'rgba(0,0,0,0)';
                cartDrawer.classList.remove('WI_cartDrawerinActive');
                setTimeout(() => {
                    this.style.display = "none";
                },310);
            },10);
        }
    }
}
customElements.define("wi-cartdrawer", WIcartDrawer);

class WIcartDrawerInfo extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.incQuantity.bind(this));
        this.addEventListener('click', this.decQuantity.bind(this));
        this.addEventListener('click', this.revQuantity.bind(this));
    };
    connectedCallback() {
        this.quickAddUpdate();
        // this.defaultATC();
        // this.totalSaving();
        // this.freeShipping();
        this.cartBubble();
        this.cartDiscount();
        this.loadRecommendations();
    }

    // Dynamic "You may also like" upsell via Shopify's Product Recommendations API
    async loadRecommendations() {
        const container = document.querySelector('[data-cart-recommendations]');
        if (!container) return;
        const productId = container.getAttribute('data-product-id');
        const baseUrl = container.getAttribute('data-url');
        if (!productId || !baseUrl) return;
        try {
            const url = `${baseUrl}?section_id=wi-cart-recommendations&product_id=${productId}&limit=10&intent=related`;
            const res = await fetch(url);
            const text = await res.text();
            // The Section Rendering API wraps output in a .shopify-section div.
            // Unwrap it so the product cards become direct children of the flex container.
            const parsed = document.createElement('div');
            parsed.innerHTML = text.trim();
            const section = parsed.querySelector('.shopify-section');
            container.innerHTML = section ? section.innerHTML : text.trim();
        } catch (error) {
            console.log("cart recommendations", error);
        }
    }

    async updateCart() {
        let res = await fetch('/?section_id=wi-cartdrawer');
        let text = await res.text();
        let html = document.createElement('div');
        html.innerHTML = text;
        let cartItems = html.querySelector('.WI_cartDrawerin_cart').innerHTML;
        document.querySelector('.WI_cartDrawerin_cart').innerHTML = cartItems;
        this.loadRecommendations();
        this.cartDiscount();
        // this.totalSaving();
        // this.freeShipping();
        this.cartBubble();
        let cartDrawer = document?.querySelector('.WI_cartDrawerin');
        if(cartDrawer) {
            if (!cartDrawer.classList.contains('WI_cartDrawerinActive')) {
                document.dispatchEvent(new CustomEvent('opencart', {bubbles: true}));
            }
        }
    }
    // update cart bubble 
    async cartBubble() {
        try {
            let res = await fetch('/cart.js');
            let data = await res.json();
            let quantityItem = data.item_count;
            let cartBubble = document.querySelectorAll('.WI_cartBubble');
            cartBubble.forEach(b => {
                if (quantityItem > 0) {
                    b.style.opacity = "1";
                    b.innerHTML = quantityItem;
                } else {
                    b.style.opacity = "0";
                    b.innerHTML = 0;
                }
            });
        } catch (error) {
            console.log("cart bubble", error);
        }
    }

    quickAddUpdate() {
        document.addEventListener('updateCart', () => {
            this.updateCart();
        })
    }
    async incQuantity(event) {
        if (event.target.matches('.WI_cartDrawer_plus')) {
            let rOOt = event.target;
            let cartItem = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement;
            let keyID = cartItem.getAttribute('data-itemKey');
            let maxQuantity = Number(cartItem.getAttribute('data-maxQuantity') || 9999);
            let quantity = Number(rOOt.parentElement.parentElement.querySelector('input').value);
            if (quantity >= maxQuantity) return;
            let newQuantity = quantity + 1;
            cartItem.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');
            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [keyID]: newQuantity
                    }
                })
            });
            this.updateCart();
        }
    }
    async decQuantity(event) {
        if (event.target.matches('.WI_cartDrawer_minus')) {
            let rOOt = event.target;
            let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
            let quantity = Number(rOOt.parentElement.parentElement.querySelector('input').value);
            let newQuantity = quantity - 1;
            rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');

            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [keyID]: newQuantity
                    }
                })
            });
            this.updateCart();
        }
    }
    async revQuantity(event) {
        if (event.target.matches('.cartDrawerRemove')) {
            let rOOt = event.target;
            let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
            let quantity = 0;
            rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');
            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [keyID]: quantity
                    }
                })
            });
            this.updateCart();
        }
    }

    // Adding cart discount 
    cartDiscount() {
        let disValue = this?.querySelector('#WI_cartDiscount');
        let disBtn = this?.querySelector('#WI_cartDiscount_btn');
        if (!disBtn) {
            return;
        }
        disBtn.addEventListener('click', async () => {
            if (!disValue.value) {
                alert('Discount input is empty');
                return;
            }

            this.querySelector('.WI_loadingSpiner').style.display = "flex";
            let disUpdates = { discount: disValue.value};

            try {
                await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(disUpdates)
                });
                    this.updateCart();
            } catch (error) {
                console.log("Cart discount error - "+error);
            }
        });
    };
    
    defaultATC() {
        const allForm = document.querySelectorAll('form[action="/cart/add"]');
        allForm.forEach(elem => {
            elem.addEventListener('submit', async (e) => {
                e.preventDefault();
                let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
                let emptyCart = document.querySelector('.WI_cartDrawerin_cart_empty');
                document.dispatchEvent(new CustomEvent('openCart', {
                    bubbles: true
                }));
            })
        });
    }

}
customElements.define("wi-cartdrawer-info", WIcartDrawerInfo);